angular.module('ui.shell',
    [
        'ui.home',
        'ui.order',
        'ui.help',
        'ui.user'
    ])
    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('client', {
            url: '/client',
            template: customTemplateResolverProvider.get('shell.html', 'app/ui/shell/shell.html'),
            controller: 'ClientController',

            data: {pageTitle: 'OrderManager: Tracking Client'},

            resolve: {
                translationsInitPromise: function (appLocale) {
                    return appLocale.loading.ensureLoaded();  // hold state initialization until promise will be resolved
                },
                currentUser: function (usersRepository) {
                    return usersRepository.getCurrentUser();
                }
            }
        });
    })

    .controller('ClientController', function ClientController($state, $scope, currentUser) {
        $scope.user = currentUser;

        $scope.submitSearch = function () {
            $state.go('client.orders', {
                step: $state.params.step ? $state.params.step : 'all-open',
                search: $scope.search
            });
            $scope.search = null;
        };

        //hack that will hide loading screen, when main state is ready
        if(window.omHideLoadingScreenCallback) {
            window.omHideLoadingScreenCallback();
        }

    })
;